import axios from 'axios';
import { Configuration, DefaultApiFactory } from '@cdaas/api-clients/dist/asset-feature-flag-openapi';

const assetServiceConfig = new Configuration({
  basePath: process.env.REACT_APP_ASSET_SERVICE_URL,
});

export const assetServiceFeatureFlagsClient = DefaultApiFactory(assetServiceConfig, undefined, axios);
